<app-navbar></app-navbar>

<div class="login-container">
  <div class="login-card">
    <img class="logo" src="assets/images/logo.png" alt="Logo" />
    <div class="row">
      <div class="col-md-6">
        <p>Bievenue {{userName}},</p>
        <p>Vous y êtes presque ! Pour commencer à utiliser votre espace ABM, veuillez définir un mot de passe associé au compte. Notez-le précieusement.</p>
        <p>Votre mot de passe doit contenir au moins:</p>
        <ul>
          <li>12 caractères</li>
          <li>1 majuscule et 1 miniscule</li>
          <li>1 caractère spécial</li>
          <li>1 nombre</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="field">
          <input id="password" placeholder="Mot de passe" type="password" [(ngModel)]="password" />
        </div>
        <div class="field">
          <input id="password2" placeholder="Confirmer mot de passe" type="password" [(ngModel)]="password2" />
        </div>
        <div class="field">
          <button *ngIf="!isLoading" type="button" (click)="register()">S'inscrire</button>
          <mat-progress-spinner
            *ngIf="isLoading"
            mode="indeterminate"
            diameter="40"
            class="spinner">
          </mat-progress-spinner>
        </div>
      </div>
    </div>
    <div class="field">
      <small>
        <a routerLink="/login">Déjà inscrit ? Se connecter.</a>
      </small>
    </div>
  </div>
</div>
